<template>
  <PositionDialogs
    :value="value"
    center
    title="Retire Position"
    :message="message"
    icon="org_icon_position"
    actionLabel="Retire"
    buttonType="terminated"
    @input="emit('input', $event)"
    @onAction="emit('onAction')"
    @onClose="emit('onClose')"
  />
</template>

<script setup>
import { computed } from "vue";
import PositionDialogs from "@components/PositionDialogs/PositionDialogs.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    default: "<position name>"
  }
});

const emit = defineEmits(["input", "onAction", "onClose"]);

const message = computed(() => {
  return `Position ${props.name} is about to be Retired. \nAll assignments to this position will be Retired.`;
});
</script>
